import {sync} from 'vuex-pathify'
import EvoLabel from "./partials/EvoLabel";
import EvoError from "./partials/EvoError";
export default {
    components: {EvoLabel, EvoError},
    props: ['field', 'name','step'],
    computed: {
        value: sync('form_data/:name')
    },
}
